import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

type Props<TReminder extends { date: Date }> = {
	id: string;
	duplicate: TReminder;
	onOpen: (reminder: TReminder) => void;
};

export const ReminderDuplicateAlert = <TReminder extends { date: Date }>({
	id,
	duplicate,
	onOpen,
}: Props<TReminder>) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack
			id={id}
			role="alert"
			direction="row"
			alignItems="flex-start"
			gap={0.6}
			mb={theme.spacingTokens.sm}
		>
			<Box flexShrink={0} mt="2px" display="inline-flex">
				<Info size={14} color={theme.palette.amber[600]} aria-hidden />
			</Box>
			<Stack flex={1} minWidth={0} alignItems="flex-start">
				<Typography
					variant="caption"
					component="p"
					color={theme.palette.amber[700]}
					lineHeight={1.5}
				>
					{t(Resources.Reminders.Form.duplicateDate, {
						date: dateFormatter(duplicate.date),
					})}
				</Typography>
				<Button
					variant="textLink"
					size="small"
					onClick={() => onOpen(duplicate)}
				>
					{t(Resources.Reminders.Form.openExisting)}
				</Button>
			</Stack>
		</Stack>
	);
};
